import courseApi from '../../../api/training/course'

// initial state
const state = {
  all: [],
  course: null,
  // coursePdfUrl: null
  proposalFormReport: [],
  yearProposalForm: []
}

// getters
const getters = {
  // getCourseById: (state, getters) => (id) => {
  //   // console.log('getCourseById: ' + id)
  //   const c = state.all.find(course => course.pcDetail.id === id)
  //   // console.log('getCourseById: ' + state.all.length)
  //   // if (c !== undefined) {
  //   //   console.log('course: ' + c.id)
  //   // }
  //   return c
  // }
}

// actions
const actions = {
  getAllCurrentCourse ({ commit }) {
    return new Promise((resolve, reject) => {
      courseApi.getAllCurrentCourse(courses => {
        commit('setCourses', courses)
        resolve()
      })
    })
  },
  getCourse ({ commit, state }, cid) {
    const course = state.all.find(course => course.pcDetail.id === cid)
    commit('setCourse', course)
    // courseApi.getCourseOutlinePath(state.course.pcDetail.outlineDmsId, cb => { commit('setCoursePdfUrl', cb) })
  },
  setClassCodeCourse ({ commit }, course) {
    commit('setCourse', course)
  },
  putCourseIntoCourses ({ commit }, course) {
    commit('addCourseIntoCourses', course)
  },
  getProposalFormReport ({ commit }, year) {
    courseApi.getSubordinateIPFormReport(cb => {
      commit('setProposalFormReport', cb)
      let report = []
      if (state.proposalFormReport.length > 0) {
        report = state.proposalFormReport.filter(r => r.refYear === year)
        commit('setYearProposalForm', report)
      }
    })
  },
  getProposalFormReportByYear ({ commit }, year) {
    let report = []
    if (state.proposalFormReport.length > 0) {
      report = state.proposalFormReport.filter(r => r.refYear === year)
      commit('setYearProposalForm', report)
    }
  }
  // getCoursePdfPath ({ commit, state }) {
  //   courseApi.getCourseOutlinePath(state.course.outlineDmsId, cb => { commit('setCoursePdfUrl', cb) })
  // }

}

// mutations
const mutations = {
  setCourses (state, courses) {
    state.all = courses
  },
  setCourse (state, course) {
    state.course = course
  },
  addCourseIntoCourses (state, course) {
    state.all.push(course)
  },
  setCoursePdfUrl (state, url) {
    state.coursePdfUrl = url
  },
  setProposalFormReport (state, report) {
    state.proposalFormReport = report
  },
  setYearProposalForm (state, report) {
    state.yearProposalForm = report
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
